/**
 * Abanico de 3 fotos del creador: cerrado se ven apiladas y ligeramente giradas; al pasar el
 * mouse o tocarlas se abren en abanico. Las fotos salen del panel (config.photos).
 */
import React, { useState } from 'react';

interface GalleryFanProps {
  photos: string[];
  name: string;
  className?: string;
}

export default function GalleryFan({ photos, name, className = '' }: GalleryFanProps) {
  const [spread, setSpread] = useState(false);
  const shown = [0, 1, 2].map((i) => photos[i % Math.max(photos.length, 1)]).filter(Boolean);
  if (!shown.length) return null;

  return (
    <button
      type="button"
      aria-label={spread ? 'Cerrar el abanico de fotos' : 'Abrir el abanico de fotos'}
      aria-pressed={spread}
      onClick={() => setSpread((v) => !v)}
      className={`gallery-fan ${spread ? 'is-spread' : ''} ${className}`}
    >
      {shown.map((src, i) => (
        <span key={i} className="gallery-fan-photo" style={{ '--fan-index': i - 1 } as React.CSSProperties}>
          <img src={src} alt={`${name} · foto ${i + 1}`} loading={i === 1 ? 'eager' : 'lazy'} draggable={false} />
        </span>
      ))}
    </button>
  );
}
